import GeneralInformation from "@/services/GeneralInformation";

export default {
  namespaced: true,

  state: () => ({
    installed:
      localStorage.getItem("installed") === "true"
        ? true
        : localStorage.getItem("installed") === "false"
        ? false
        : null,
    bootstrapped: false,
  }),

  mutations: {
    SET_INSTALLED(state, value) {
      state.installed = value;
      localStorage.setItem("installed", value);
    },
    SET_BOOTSTRAPPED(state) {
      state.bootstrapped = true;
    },
  },

  actions: {
    async bootstrap({ commit, state, dispatch }) {
      if (state.bootstrapped) return;
      try {
        if (localStorage.getItem("installed") === "true") {
          commit("SET_INSTALLED", true);
          await dispatch("system/fetchSystemInfo", null, { root: true });
          return;
        }
        const res = await GeneralInformation.fetchSystemStatus();
        let data = res.data == 1 ? true : false;
        commit("SET_INSTALLED", data);

        // fetch system info ONLY if installed
        if (data) {
          await dispatch("system/fetchSystemInfo", null, { root: true });
        }

        commit("SET_BOOTSTRAPPED");
      } catch (e) {
        console.error("App bootstrap failed", e);
      }
    },
  },

  getters: {
    isInstalled: (s) => s.installed,
    isBootstrapped: (s) => s.bootstrapped,
  },
};
